import React, { Component } from "react";
import request from "request";
import { apiUrl } from "../util";
class SendToProblemQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      problem: "",
      delete: true,
      isOpen: false,
      removing: false,
    };
  }
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  open = e => {
    e.preventDefault();
    this.setState({ isOpen: true });
  };
  handleDelete = e => {
    this.setState({
      delete: !!e.currentTarget.checked,
    });
  };
  highPriority = e => {
    e.preventDefault();

    if (
      window.confirm(
        "Are you sure you want to do this? \n This means we will start checking this URL regularly again."
      )
    ) {
      request.post(
        {
          url: `${apiUrl}/v1/admin/v2/editTrackedUrl`,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          form: {
            url: this.props.url,
            priority: "normal",
            fromQueue: false,
          },
        },
        (err, res, data) => {
          if (err) {
            return;
          }
          this.setState({
            isOpen: false,
            removing: false,
          });
          if (this.props.callback) {
            this.props.callback();
          } else {
            alert("Done!");
          }
        }
      );
    }
  };
  lowPriority = e => {
    e.preventDefault();

    if (
      window.confirm(
        "Are you sure you want to do this? \nThis means the URL will no longer be checked on a regular basis."
      )
    ) {
      request.post(
        {
          url: `${apiUrl}/v1/admin/v2/editTrackedUrl`,
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          form: {
            url: this.props.url,
            priority: "low",
            fromQueue: true,
          },
        },
        (err, res, data) => {
          if (err) {
            return;
          }
          this.setState({
            isOpen: false,
            removing: false,
          });
          if (this.props.callback) {
            this.props.callback();
          } else {
            alert("Done!");
          }
        }
      );
    }
  };

  sendToQ = e => {
    e.preventDefault();
    this.setState({ removing: true });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/problem`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: {
          url: this.props.url,
          platform: this.props.platform,
          comment: `${this.state.problem} -- ${this.state.comment}`,
          sid: this.props.sid,
          email:
            this.state.problem === "Real test but screenshot looks off" ||
            this.state.problem === "No screenshot"
              ? true
              : false,
          qid: this.state.delete ? this.props.qid : undefined,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.setState({
          isOpen: false,
          removing: false,
        });
        if (this.props.callback) {
          this.props.callback();
        } else {
          alert("Sent to problem queue!");
        }
      }
    );
  };
  remove = e => {
    e.preventDefault();
    this.setState({ removing: true });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id: this.props.qid, url: this.props.url },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        if (this.props.callback) {
          this.props.callback();
        } else {
          alert("Deleted from queue!");
        }
        this.setState({
          removing: false,
        });
      }
    );
  };
  render() {
    const { isOpen } = this.state;
    const { urlInfo } = this.props;
    return (
      <>
        <div className={this.state.removing ? "o-40" : ""}>
          {!isOpen && (
            <a href="#" onClick={this.open}>
              report a problem
            </a>
          )}
          {isOpen && (
            <form className="db">
              <div>
                <select name="problem" onChange={this.handleChange}>
                  <option value="">--- pick a reason ---</option>
                  <option value="Page not captured properly">
                    Page not captured properly
                  </option>
                  <option value="Real test but screenshot looks off">
                    Real test but screenshot looks off!
                  </option>
                  <option value="No screenshot"> No screenshot </option>
                  <option value="Broken Images / missing images">
                    Broken Images / missing images
                  </option>
                  <option value="Ads / internal promo">
                    Ads / internal promo
                  </option>
                  <option value="Animations / counters">
                    Animations / counters
                  </option>
                  <option value="Cookie banner">Cookie banner</option>
                  <option value="Captcha">Captcha</option>
                  <option value="Chat bot">Chat bot</option>
                  <option value="Issue with video">Issue with video</option>
                  <option value="Not a real test">Not a real test</option>
                  <option value="No visible difference">
                    No visible difference
                  </option>
                  <option value="Promo causes false positive">
                    Promo causes false positive
                  </option>
                  <option value="Survey">Survey</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div>
                <label for={`remove_${this.props.qid}`}>
                  <input
                    type="checkbox"
                    checked={this.state.delete}
                    name="remove"
                    id={`remove_${this.props.qid}`}
                    onChange={this.handleDelete}
                  />{" "}
                  Remove from started/ended/screening queue
                </label>
              </div>
              <textarea onChange={this.handleChange} name="comment" />
              <button style={{ marginLeft: "6px" }} onClick={this.sendToQ}>
                Send
              </button>
            </form>
          )}
        </div>
        <div className="mt1">
          {this.props.qid && (
            <span className="mr2">
              <a href="#" onClick={this.remove} className="mr2">
                remove from queue
              </a>
              &middot;
            </span>
          )}
          {urlInfo &&
            urlInfo.priority &&
            urlInfo.priority === "discontinued" && (
              <span className="mr2">
                <b className="red mr2">We are no longer tracking this URL</b>
                &middot;
              </span>
            )}
          {urlInfo && urlInfo.priority && urlInfo.priority === "low" && (
            <span className="mr2">
              <b className="red mr2">This URL is low priority</b>
              &middot;
            </span>
          )}
          {urlInfo &&
          urlInfo.priority &&
          (urlInfo.priority === "discontinued" ||
            urlInfo.priority === "low") ? (
            <a href="#" onClick={this.highPriority}>
              Start checking this URL regularly
            </a>
          ) : (
            <a href="#" onClick={this.lowPriority}>
              Stop checking this URL regularly
            </a>
          )}
        </div>
      </>
    );
  }
}

export default SendToProblemQueue;
